// Swap Material Hamburger Icon for Clear Icon
jQuery('[data-ham-icon]').on('click',function(){
    var hamburger_icon = jQuery('[data-ham-icon]');
    if(hamburger_icon.text() === 'menu'){
        hamburger_icon.text('clear');
    }else{
        hamburger_icon.text('menu');
    }
});

jQuery(document).on('closed.zf.offcanvas', function () {
    jQuery('[data-ham-icon]').text('menu');
});

// Smooth Scroll
// jQuery('a[href*=#]:not([href=#])').click(function() {
//     if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'')
//         || location.hostname == this.hostname) {
//
//         var target = $(this.hash);
//         target = target.length ? target : jQuery('[name=' + this.hash.slice(1) +']');
//         if (target.length) {
//             jQuery('html,body').animate({
//                 scrollTop: target.offset().top
//             }, 1000);
//             return false;
//         }
//     }
// });